import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/* eslint-env browser */
import { useRef } from 'react';
import { useDeviceType, useTap } from '../../../hooks';
import { navigateNext } from '../../../helpers/events-navigate';

var useCarouselTap = function useCarouselTap(_ref) {
  var navigateOnClick = _ref.navigateOnClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["navigateOnClick", "disabled"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var ref = useRef(null);

  var onTap = function onTap(e, _ref2) {
    var x = _ref2.x;
    var onActiveItemIndexChange = props.onActiveItemIndexChange,
        nextItemIndex = props.nextItemIndex,
        previousItemIndex = props.previousItemIndex;

    if (navigateNext(x, ref)) {
      onActiveItemIndexChange(nextItemIndex);
    } else {
      onActiveItemIndexChange(previousItemIndex);
    }
  };

  var _useTap = useTap(onTap, ref, hasTouchScreen, disabled || !navigateOnClick),
      setRef = _useTap.setRef;

  return {
    setTapRef: setRef
  };
};

export default useCarouselTap;